import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiMessageCircle } = FiIcons;

export default function SecondaryButton({ 
  text = "Guide Me on WhatsApp", 
  link = "https://link.ajedolabomi.com/whatsapp-help",
  className = "" 
}) {
  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      className={`inline-flex items-center justify-center gap-2 text-emerald-700 font-bold py-4 px-8 rounded-full border-2 border-emerald-200 hover:border-emerald-500 hover:bg-emerald-50 transition-all duration-200 text-lg shadow-sm ${className}`}
    >
      <SafeIcon icon={FiMessageCircle} className="text-xl" />
      {text}
    </a>
  );
}